import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  // region Atributos
  private API_URL = environment.url;
  // endregion

  // region Constructor
  constructor(private httpClient: HttpClient) {}
  // endregion

  //#region Métodos

  // Obtiene el listado de grupos
  getUserNotifications(iduser): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/notification/show/${iduser}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  sendNotifications(data): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/notification/store`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  deleteNotification(id): Observable<any> {
    return this.httpClient.delete<any>(`${this.API_URL}/notification/delete/${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
